var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/hover-ref-wrapper.tsx";
import classNames from 'clsx';
import debounce from 'lodash/debounce';
import React, { useRef } from 'react';
import { fetchAccount } from 'soapbox/actions/accounts';
import { openProfileHoverCard, closeProfileHoverCard } from 'soapbox/actions/profile-hover-card';
import { useAppDispatch } from 'soapbox/hooks';
import { isMobile } from 'soapbox/is-mobile';
const showProfileHoverCard = debounce((dispatch, ref, accountId) => {
  dispatch(openProfileHoverCard(ref, accountId));
}, 600);

/** Makes a profile hover card appear when the wrapped element is hovered. */
export const HoverRefWrapper = _ref => {
  let {
    accountId,
    children,
    inline = false,
    className
  } = _ref;
  const dispatch = useAppDispatch();
  const ref = useRef(null);
  const Elem = inline ? 'span' : 'div';

  const handleMouseEnter = () => {
    if (!isMobile(window.innerWidth)) {
      dispatch(fetchAccount(accountId));
      showProfileHoverCard(dispatch, ref, accountId);
    }
  };

  const handleMouseLeave = () => {
    showProfileHoverCard.cancel();
    setTimeout(() => dispatch(closeProfileHoverCard()), 300);
  };

  const handleClick = () => {
    showProfileHoverCard.cancel();
    dispatch(closeProfileHoverCard(true));
  };

  return /*#__PURE__*/React.createElement(Elem, {
    ref: ref,
    className: classNames('hover-ref-wrapper', className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }, children);
};
export { HoverRefWrapper as default, showProfileHoverCard };